var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-text"},[_vm._v("Loading, please wait ...")])
}
var staticRenderFns = []

export { render, staticRenderFns }